import { render, staticRenderFns } from "./VerifyWabaCode.vue?vue&type=template&id=52c8f645&"
import script from "./VerifyWabaCode.vue?vue&type=script&lang=js&"
export * from "./VerifyWabaCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports